module.exports = __webpack_public_path__ + "img/paypal.8f471837.png";